export default __webpack_public_path__ + "static/media/Roche_60s.5889bab3.mp4";